<template>
  <Card class="position-relative">
    <template #cardBody>
      <div class="row">
        <div class="col-md-2">
          <div class="position-relative w-40px">
            <AvatarBadge v-if="isGroupConversation" class="rounded-full symbol-50px" :fullname="discussionName" />
            <AvatarBadge v-else class="rounded-full symbol-50px" :fullname="discussionName" :online="isOnline" :avatar-url="discussion.peer?.avatar_url" />
          </div>
        </div>
        <div class="col-md-10">
          <div class="d-flex flex-column">
            <div class="d-flex justify-content-between">
              <span v-if="discussion.group_type !== groupTypeEnums.CLIENT_SERVICE" class="fw-bold text-gray-800 text-hover-primary fs-3"> {{ discussionName }} </span>
              <span v-else class="fw-bold text-gray-800 text-hover-primary fs-3"> {{ 'Service Client ' + discussionName }} </span>
            </div>
            <div>
              <span v-if="lastMessage && lastMessage.type === 'TEXT'" class="mt-auto text-muted small fw-bol"> {{ subText(lastMessage.content) }} </span>
            </div>
            <div v-if="discussion.with_customer">
              <span class="badge badge-light-primary"> {{ $t('customer') }} </span>
            </div>
          </div>
        </div>
      </div>
      <span v-if="discussion.unread" class="position-absolute end-0 top-0 mt-3 me-5 badge badge-primary badge-circle "> {{ discussion.unread }} </span>
      <span class="position-absolute end-0 me-5 text-muted small fw-bold"> {{ displayLastDate(discussion.last_update) }} </span>
    </template>
  </Card>
</template>

<script setup>

import Card from "@/components/Card.vue";
import AvatarBadge from "@/components/AvatarBadge.vue";
import {computed} from "vue";
import {$dateFormatter, getDateHour, isToday, subText} from "@/mixins/Helpers";
import {useLocales} from "@/composables/locales";
import { useStore } from 'vuex'
import {useChatEnums} from "@/Modules/Chat/composables/chatEnums";

const { locale } = useLocales()
const { groupTypeEnums } = useChatEnums()
const store = useStore()

const props = defineProps({
  discussion: {
    type: Object,
    required: true
  }
})

const getSelectCompanyId = computed(() => store.getters['offices/getSelectCompanyId'])

const isOnline = computed(() => {
  if (props.discussion.is_group) {
    return false
  }

  return store.getters['offices/onlineDiscussion'](getSelectCompanyId.value, props.discussion?.peer?.id)
})



const discussionName = computed(() => {
  if(props.discussion.is_group) {
    return props.discussion.name
  } else {
    return props.discussion.peer?.name
  }
})

const lastDate = computed(() => {
  if(props.discussion.messages && props.discussion.messages.length > 0) {
    return props.discussion.messages[0]?.created_at
  } else {
    return props.discussion.created_at
  }
})

const lastMessage = computed(() => {
  if(props.discussion.last_message) {
    return props.discussion.last_message
  } else {
    return ''
  }
})

const isGroupConversation = computed(() => !!props.discussion?.is_group)

const displayLastDate = (date) => {
  if(isToday(date)) {
    return getDateHour(date, locale.value)
  } else {
    return $dateFormatter(date, locale.value)
  }
};


</script>

<style scoped>
.rounded-2 {
  border-radius: 10px!important;
}
</style>